import { createFileRoute } from '@tanstack/react-router'
import { FounderLayout } from '../../../../components/founder-layout'
import { WorkspaceReadyGuard } from '../../../../components/workspace-ready-guard'
import { OutreachArchiveView } from '../../../../features/outreach/components/outreach-archive-view'

export const Route = createFileRoute('/app/startup/$id/outreach/archive')({
  component: OutreachArchivePage,
})

function OutreachArchivePage() {
  const { id: startupId } = Route.useParams()
  return (
    <WorkspaceReadyGuard>
      <FounderLayout activeNav="">
        <OutreachArchiveView startupId={startupId} />
      </FounderLayout>
    </WorkspaceReadyGuard>
  )
}
